import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import * as types from "@board/store/types";
import * as accountTypes from "@account/store/types";
import { mapGetters, mapActions } from "vuex";
import { cache, getLangProperty } from "@appbase/util";
import * as dateutil from "@appbase/util/date-helper";
import * as usertypes from "@account/store/types";

import UserCardComponent from "@/modules/@appbase/components/common/UserCard/UserCardComponent";

@Component({
    computed: {
        ...mapGetters({
            user: accountTypes.USER,
            userCurrent: usertypes.CURRENT,
        }),
    },

    methods: {
        ...mapActions({
            fetchArticleComment: types.FETCH_COMMENT,
            createComment: types.CREATE_COMMENT,
            deleteComment: types.DELTE_COMMENT,
        }),
    },
})
export default class CommentBox extends UserCardComponent {
    @Prop({ type: Number }) articleId!: number;
    @Prop({ type: Boolean, default: true }) showComment!: boolean;
    @Prop({ type: Boolean, default: false }) nameless!: boolean;

    fetchArticleComment!: (article: article.CommentFetchSet) => Promise<article.PagedData<article.ArticleComment>>;
    createComment!: (set: article.CreateComment) => Promise<article.ArticleComment>;
    deleteComment!: (commentId: number) => Promise<article.ArticleComment>;

    user!: account.User;
    userCurrent!: account.TCurrent;
    userLang: string = "";
    mUserPhoto: string = "/cm/gres/images/ghost.png";
    commentsModel: any[] = [];
    commnetPhotos: article.CommentPhoto[] = [];
    commentPhotoMounted: boolean = false;
    mComment: string = "";

    @Watch("showComment")
    onShowChanged(newVal: boolean) {
        if (newVal) {
            this.mountComments();
        }
    }

    created() {
        this.userLang = this.userCurrent.userConfig.language; //현재 사용자의 언어 설정 정보
        this.onShowChanged(this.showComment);
        cache.avatar.get(this.user.personCode).then((res) => {
            this.mUserPhoto = res;
        });
    }

    langProperty(obj: Object, propKey: string) {
        return getLangProperty(obj, propKey);
    }

    getCreatedDate(createdDate: Date) {
        return dateutil.uGetDateFormat("yyyy-MM-dd", new Date(createdDate.toString()));
    }

    getCreateTime(createdDate: Date) {
        return dateutil.uGetDateFormat("H:i", new Date(createdDate.toString()));
    }

    getCommentEditable(comment: article.ArticleComment) {
        if (comment.userCode === this.user.personCode) return true;
        else return false;
    }

    sortComments(comments: article.ArticleComment[]) {
        var returnModel: any[] = comments.filter((c) => c.replyTo == null);

        var appendReplies = function (remains: article.ArticleComment[]) {
            if (remains.length == 0) return;

            var nextRemains: article.ArticleComment[] = [];
            remains.forEach((r) => {
                var idx = returnModel.findIndex((m) => m.commentId == r.replyTo);

                if (idx >= 0) {
                    var parentComment = returnModel[idx];
                    var model = {
                        ...r,
                        replyToName: parentComment.userName,
                    };

                    returnModel.splice(idx + 1, 0, model);
                } else {
                    nextRemains.push(r);
                }
            });

            if (comments.length == nextRemains.length) return;

            appendReplies(nextRemains);
        };

        appendReplies(comments.filter((c) => c.replyTo != null));
        return returnModel.map(
            (m) =>
                <any>{
                    ...m,
                    contentAfter: m.content,
                    onEdit: false,
                    isReplyModel: false,
                }
        );
    }

    mountComments() {
        return this.fetchArticleComment(<article.CommentFetchSet>{
            articleId: this.articleId,
            // itemsPerPage = 0 : 모든 댓글 FETCH
            itemsPerPage: 0,
            page: 1,
        }).then((res) => {
            this.commentsModel = this.sortComments(res.data);
            this.mountCommentPhotos(this.commentsModel, res.data.length);
            this.$emit("commentMounted", res.data, res.data.length);
        });
    }

    mountCommentPhotos(comments: article.ArticleComment[], length: number) {
        this.commentPhotoMounted = false;
        var photoPromise: Promise<string>[] = [];

        comments.forEach((c) => photoPromise.push(cache.avatar.get(c.userCode)));
        Promise.all(photoPromise).then((res) => {
            this.commnetPhotos = res.map((r) => <article.CommentPhoto>{ photoUrl: r, isReplyModel: false });
            this.commentPhotoMounted = true;
        });
    }

    async onClickUpdateComment(comment: any, idx: number) {
        let modelIdx: number = this.commentsModel.findIndex((cm) => cm.isReplyModel || cm.onEdit);
        if (modelIdx >= 0) {
            await (window as any).alertAsync(this.$t("작성중인_답글창이_존재").toString());
            var focusElem = (this.$refs.refTextArea as HTMLElement[])[0] as HTMLTextAreaElement;
            focusElem?.focus();
            return;
        }

        comment.onEdit = true;
    }

    createArticleComment() {
        if (this.mComment.length == 0) {
            (window as any).alertAsync(this.$t("M_BB_CommentIsNull").toString());
            return;
        }

        this.createComment(<article.CreateComment>{
            createdUser: this.nameless
                ? null
                : {
                      deptName: this.user.deptName,
                      deptName_En: this.user.deptNameEn,
                      deptName_Ch: this.user.deptNameCh,
                      deptName_Jp: this.user.deptNameJp,
                      userCode: this.user.id,
                      userJobTitle: this.user.titleName,
                      userJobTitle_En: this.user.titleNameEn,
                      userJobTitle_Ch: this.user.titleNameCh,
                      userJobTitle_Jp: this.user.titleNameJp,
                      userName: this.user.displayName,
                      userName_En: this.user.displayNameEn,
                      userName_Ch: this.user.displayNameCh,
                      userName_Jp: this.user.displayNameJp,
                  },
            replyTo: null,
            articleId: this.articleId,
            content: this.mComment,
        }).then((res) => {
            this.mComment = "";
            this.mountComments();
        });
    }

    //'댓글 수정' 버튼 클릭 시
    updateArticleComment(comment: any) {
        this.createComment(<article.CreateComment>{
            createdUser: {
                deptName: this.user.deptName,
                deptName_En: this.user.deptNameEn,
                deptName_Ch: this.user.deptNameCh,
                deptName_Jp: this.user.deptNameJp,
                userCode: this.user.id,
                userMail: this.user.email,
                userDept: this.user.deptCode,
                userPhone: this.user.officeTel,
                userJobTitle: this.user.titleName,
                userJobTitle_En: this.user.titleNameEn,
                userJobTitle_Ch: this.user.titleNameCh,
                userJobTitle_Jp: this.user.titleNameJp,
                userName: this.user.displayName,
                userName_En: this.user.displayNameEn,
                userName_Ch: this.user.displayNameCh,
                userName_Jp: this.user.displayNameJp,
            },
            replyTo: comment.isReplyModel ? comment.replyTo : null,
            articleId: this.articleId,
            content: comment.contentAfter,
            commentId: comment.commentId,
        }).then((res) => {
            this.mountComments();
        });
    }

    async deleteArticleComment(commentId: number) {
        let deleteMessage: string = this.$t("M_BB_DeleteMessage") as string;
        var returnMessage = await (window as any).confirmAsync(deleteMessage);

        if (returnMessage) {
            this.deleteComment(commentId).then((res) => {
                this.mountComments();
            });
        }
    }

    async replyArticleComment(commentId: number, idx: number) {
        let modelIdx: number = this.commentsModel.findIndex((cm) => cm.isReplyModel || cm.onEdit);
        if (modelIdx >= 0) {
            await (window as any).alertAsync(this.$t("작성중인_답글창이_존재").toString());
            var focusElem = (this.$refs.refTextArea as HTMLElement[])[0] as HTMLTextAreaElement;
            focusElem?.focus();
            return;
        }

        this.commnetPhotos.splice(idx + 1, 0, { photoUrl: this.mUserPhoto, isReplyModel: true });
        this.commentsModel.splice(idx + 1, 0, {
            commentId: null,
            articleId: this.articleId,
            replyTo: commentId,
            content: "",
            createdDate: new Date(),
            userCode: this.user.id,
            userName: this.user.displayName,
            userName_En: this.user.displayNameEn,
            userName_Ch: this.user.displayNameCh,
            userName_Jp: this.user.displayNameJp,
            userDeptName: this.user.deptName,
            userDeptName_En: this.user.deptNameEn,
            userDeptName_Ch: this.user.deptNameCh,
            userDeptName_Jp: this.user.deptNameJp,
            userJobTitle: this.user.titleName,
            userJobTitle_En: this.user.titleNameEn,
            userJobTitle_Ch: this.user.titleNameCh,
            userJobTitle_Jp: this.user.titleNameJp,
            contentAfter: "",
            onEdit: true,
            isReplyModel: true,
        });
    }

    onCommentEditCancel(comment: any) {
        comment.onEdit = false;
        this.commentsModel = this.commentsModel.filter((c) => !c.isReplyModel);
        this.commnetPhotos = this.commnetPhotos.filter((p) => !p.isReplyModel);
    }
}
